export function checkVisible(elm, tolerancia = 0) {
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    //console.log(elm.dataset.module, 'rect', rect.bottom, rect.top, 'viewHeight', viewHeight, rect.top, ' - ', viewHeight, '<', tolerancia, (rect.top - viewHeight) < tolerancia);
    return !(rect.bottom < 0 || rect.top - viewHeight >= tolerancia);
};



// WEBPACK FOOTER //
// ./Statics/scripts/common/check-visible.js